import React, { Component } from 'react';
import { ApexTree } from 'apextree';

class TreeChart extends Component {
  constructor(props) {
    super(props);
    this.treeContainer = React.createRef();
    this.tree = null;
  }

  // تنظیمات رنگ برای ۶ دپارتمان مختلف
  depts = {
    hq: {bg: '#F8FAFC', border: '#94A3B8', borderHover: '#64748B', accent: '#475569', name: 'ریاست'},
    finance: {bg: '#EFF6FF', border: '#93C5FD', borderHover: '#3B82F6', accent: '#2563EB', name: 'مالی'},
    hr: {bg: '#FDF2F8', border: '#F9A8D4', borderHover: '#EC4899', accent: '#DB2777', name: 'منابع انسانی'},
    marketing: {bg: '#FFF7ED', border: '#FDBA74', borderHover: '#F97316', accent: '#EA580C', name: 'بازاریابی'},
    product: {bg: '#F0FDF4', border: '#86EFAC', borderHover: '#22C55E', accent: '#16A34A', name: 'محصول'},
    sales: {bg: '#EEF2FF', border: '#A5B4FC', borderHover: '#6366F1', accent: '#4F46E5', name: 'فروش'},
  };

  makeOpts = (dept) => ({
    nodeBGColor: this.depts[dept].bg,
    nodeBGColorHover: this.depts[dept].bg,
    borderColor: this.depts[dept].border,
    borderColorHover: this.depts[dept].borderHover,
  });

  // تمپلیت نود (2 ردیف متن)
  nodeTemplate = (c) => `
    <div style="
      display: flex;
      flex-direction: column;
      align-items: center;
      height: 100%;
      padding: 20px 15px;
      box-sizing: border-box;
      text-align: center;
      overflow: hidden;
      font-family: 'IRANSans', 'Vazirmatn', Tahoma, sans-serif;
    ">
      <img src="${c.img}" alt=""
        style="
          width: 65px; height: 65px;
          border-radius: 50%;
          object-fit: cover;
          flex-shrink: 0;
          border: 3px solid ${c.accent};
          margin-bottom: 12px;
        " />
      <div style="font-weight: 600; font-size: 16px; color: #1e293b; line-height: 1.4; white-space: nowrap; max-width: 100%;">${c.name}</div>
      <div style="font-size: 12px; color: #64748b; margin-top: 5px; white-space: nowrap; max-width: 100%;">${c.title}</div>
    </div>`;

  // تابع کمکی برای ساخت سریع نودها
  makeNode = (id, name, title, deptKey, children = []) => ({
    id,
    data: {
      name,
      title,
      dept: this.depts[deptKey].name,
      img: `https://api.dicebear.com/9.x/initials/svg?seed=${encodeURIComponent(name)}`,
      accent: this.depts[deptKey].accent,
    },
    options: this.makeOpts(deptKey),
    children
  });

  // تابع کمکی برای ساخت چند فرزند ساده با تعداد دلخواه
  makeBatch = (prefix, deptKey, count) => {
    const arr = [];
    for(let i=1; i<=count; i++) {
      arr.push(this.makeNode(`${prefix}_${i}`, `گروه ${i}`, `مسئول گروه`, deptKey));
    }
    return arr;
  };

  // ساختار درختی
  data = this.makeNode('root', 'دکتر شهرام یزدانی', 'ریاست', 'hq', [
    this.makeNode('c1', 'معاونت اول (چپ)', 'معاون', 'finance', [
      this.makeNode('c1_1', 'بخش ۱', 'مدیر', 'finance', this.makeBatch('c1_1', 'finance', 2)),
      this.makeNode('c1_2', 'بخش ۲', 'مدیر', 'finance', this.makeBatch('c1_2', 'finance', 2)),
      this.makeNode('c1_3', 'بخش ۳', 'مدیر', 'finance', this.makeBatch('c1_3', 'finance', 6)),
    ]),
    this.makeNode('c2', 'معاونت دوم (وسط)', 'معاون', 'hr'),
    this.makeNode('c3', 'معاونت سوم (وسط)', 'معاون', 'marketing'),
    this.makeNode('c4', 'معاونت چهارم (وسط)', 'معاون', 'product'),
    this.makeNode('c5', 'معاونت پنجم (راست)', 'معاون', 'sales', [
      this.makeNode('c5_1', 'گروه پژوهش چپ', 'مدیر', 'sales', this.makeBatch('c5_1', 'sales', 4)),
      this.makeNode('c5_2', 'گروه پژوهش راست', 'مدیر', 'sales', [
        this.makeNode('c5_2_1', 'زیرگروه ۱', 'مسئول', 'sales', this.makeBatch('c5_2_1', 'sales', 5)),
        this.makeNode('c5_2_2', 'زیرگروه ۲', 'مسئول', 'sales', this.makeBatch('c5_2_2', 'sales', 4)),
        this.makeNode('c5_2_3', 'زیرگروه ۳', 'مسئول', 'sales', this.makeBatch('c5_2_3', 'sales', 3)),
      ]),
    ]),
  ]);

  options = {
    contentKey: 'data',
    nodeTemplate: this.nodeTemplate,
    width: '100%',
    viewPortWidth: 1800,
    viewPortHeight: 4500,
    nodeWidth: 220,
    nodeHeight: 170,
    childrenSpacing: 350,
    siblingSpacing: 25,
    direction: 'top',
    edgeStyle: 'orthogonal',
    edgeWidth: 1,
    enableExpandCollapse: false,
    enableToolbar: true,
    edgeColorMode: 'node',
    canvasStyle: 'border-radius: 8px; background: #ffffff;',
  };

  componentDidMount() {
    if (typeof ApexTree !== 'undefined' && this.treeContainer.current) {
      this.tree = new ApexTree(this.treeContainer.current, this.options);
      this.tree.render(this.data);

      // 🚀 ترفند حذف واترمارک و وسط‌چین کردن SVG
      setTimeout(() => {
        const container = this.treeContainer.current;
        if (!container) return;

        // 1. پاک کردن لینک‌های واترمارک
        const anchors = container.querySelectorAll('a');
        anchors.forEach(a => {
          if (a.href && (a.href.includes('apextree') || a.href.includes('apexcharts') || a.href.includes('redq'))) {
            a.remove();
          }
        });

        // 2. پاک کردن تگ‌های متنی داخل SVG (واترمارک)
        const svgTexts = container.querySelectorAll('svg text');
        svgTexts.forEach(t => t.remove());

        // 3. پاک کردن با کلاس‌های رایج واترمارک
        container.querySelectorAll('.watermark, [class*="credit"], [id*="watermark"]').forEach(el => {
          el.style.display = 'none';
        });

        // 4. وسط‌چین کردن دقیق چارت (SVG) در داخل کادر
        const svg = container.querySelector('svg');
        if (svg) {
          svg.style.margin = 'auto';
        }

      }, 300);

    } else if (typeof ApexTree === 'undefined') {
      console.error("کتابخانه ApexTree پیدا نشد!");
    }
  }

  componentWillUnmount() {
    if (this.tree) {
      this.tree = null;
    }
  }

  render() {
    return (
      <div style={{ width: '100%', padding: '10px', boxSizing: 'border-box' }}>
        <div
          ref={this.treeContainer}
          style={{
            width: '100%',
            height: '500px',          // ارتفاع دقیقاً به 500 پیکسل تغییر یافت
            overflow: 'auto',         // اسکرول در صورت نیاز
            position: 'relative',
            border: '1px solid #e2e8f0',
            borderRadius: '8px',
            background: '#ffffff',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'flex-start',
          }}
        ></div>
      </div>
    );
  }
}

export default TreeChart;